import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import Controls from "../../../components/controls/Controls";
import Norecords from "../../../components/customHelpers/Norecords";
import Loading from "../../../components/customHelpers/Loading";
import {
  Grid,
  Box,
  TableCell,
  TableRow,
  TableBody,
  Typography,
  Paper,
  Select,
  MenuItem,
  Toolbar,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import { MdOutlineDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import { FiEdit } from "react-icons/fi";
import useTable from "../../../components/customHelpers/useTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import Store from "../../../actions/store";
import AddStoreForm from "../../../components/forms/addStore";
import Popup from "../../../components/customHelpers/Popup";
import produce from "immer";
import { formatNumber } from "../../../utils/utils";

const headCells = [
  { id: "locationName", label: "Name" },
  { id: "locationAddress", label: "Address" },
  { id: "actions", label: "Actions", disableSorting: true },
];

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    minWidth: 800,
    tableLayout: "fixed",
  },
  tableCellName: {
    width: "20%",
    minWidth: 200,
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
  tableCellAddress: {
    width: "30%",
    minWidth: 200,
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
  tableCellQuantity: {
    width: "20%",
    minWidth: 150,
    whiteSpace: "nowrap",
  },
  tableCellActions: {
    width: "15%",
    minWidth: 150,
    whiteSpace: "nowrap",
  },
}));

const StorePage = () => {
  const classes = useStyles();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllStores, deleteStore } = Store();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);
  const [stores, setStores] = useState([]);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;

  useEffect(() => {
    getAllStores();
  }, [reload]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const getAllStores = () => {
    setValues({ ...values, loading: true });
    viewAllStores().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.stores) {
        setValues({
          ...values,
          loading: false,
        });
        setStores(data.stores);
      }
    });
  };

  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    deleteStore(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
        setStores(
          produce(stores, (draft) => {
            const index = stores.findIndex((role) => role.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(stores, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["locationName", "locationAddress"];
        if (target.value === "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };

  return (
    <>
      <div className="card">
        <div className="flex justify-between">
          <Typography variant="h6" className="page-header">
            Stores
          </Typography>
          <Controls.Button
            text="Add Store"
            variant="outlined"
            startIcon={<IoMdAdd />}
            className="newButton"
            onClick={() => {
              setOpenPopup(true);
              setRecordForEdit(null);
              setEdit(false);
            }}
          />
        </div>
        <Toolbar>
          <div
            className="search-header-container"
            style={{
              marginBottom: 0,
              flex: 1,
              marginLeft: -25,
              maxWidth: 260,
              minWidth: 260,
            }}
          >
            <div className="search-header-flex">
              <div className="search-container">
                <Search className="search_icon" />
                <input
                  type="text"
                  onChange={handleSearch}
                  placeholder="Search Store"
                  className="search-input"
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>
        </Toolbar>

        <Grid container>
          <Grid item xs={12} className="card__body">
            {loading ? (
              <Loading />
            ) : (
              <Paper sx={{ overflowX: "auto" }}>
                <TblContainer className={classes.tableContainer}>
                  <TblHead />
                  <TableBody>
                    {recordsAfterPagingAndSorting().length > 0 ? (
                      recordsAfterPagingAndSorting().map((item) => (
                        <TableRow key={item.Id}>
                          <TableCell className={classes.tableCellName}>
                            {item.locationName}
                          </TableCell>
                          <TableCell className={classes.tableCellAddress}>
                            {item.locationAddress}
                          </TableCell>
                      
                          <TableCell className={classes.tableCellActions}>
                            <Controls.ActionButton
                              color="secondary"
                              title="Delete"
                              onClick={() => {
                                setConfirmDialog({
                                  isOpen: true,
                                  title: "Are you sure to delete this Store?",
                                  subTitle: "You can't undo this operation",
                                  onConfirm: () => {
                                    onDelete(item.id);
                                  },
                                });
                              }}
                            >
                              <MdOutlineDelete fontSize="medium" />
                            </Controls.ActionButton>
                            <Controls.ActionButton
                              color="primary"
                              title="Update"
                              onClick={() => {
                                setOpenPopup(true);
                                setRecordForEdit(item);
                                setEdit(true);
                              }}
                            >
                              <FiEdit fontSize="medium" />
                            </Controls.ActionButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <Norecords col={4} />
                    )}
                  </TableBody>
                </TblContainer>
                <TblPagination />
              </Paper>
            )}
          </Grid>
        </Grid>

        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
        <Notification notify={notify} setNotify={setNotify} />
      </div>
      <Popup
        title="Store Form"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <AddStoreForm
          NotifyMessage={NotifyMessage}
          setOpenPopup={setOpenPopup}
          recordForEdit={recordForEdit}
          setStores={setStores}
          edite={edite}
        />
      </Popup>
    </>
  );
};

export default StorePage;
